module.exports = __webpack_public_path__ + "static/media/logo.88ea04d1.png";